import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  const total = payload.reduce((sum, p) => sum + (p.value || 0), 0);
  return (
    <div className="bg-white rounded-xl px-3 py-2 shadow-warm-md border border-surface-200 text-sm space-y-1">
      <p className="font-semibold text-ink-800">{label}</p>
      <p className="text-xs text-ink-500 font-medium">Total: {total}</p>
      {payload.map((p) => (
        <p key={p.dataKey} className="text-ink-500 flex items-center gap-2">
          <span className="inline-block w-2 h-2 rounded-full" style={{ backgroundColor: p.color }} />
          <span className="capitalize">{p.name}:</span>
          <span>{p.value?.toLocaleString() ?? 0}</span>
        </p>
      ))}
    </div>
  );
};

const NewAccountsChart = ({ stats }) => {
  const data = (stats || []).map((s) => ({
    date: s.date?.slice(5) || s.id?.slice(5),
    web: s.newAccountsByPlatform?.web || 0,
    ios: s.newAccountsByPlatform?.ios || 0,
    android: s.newAccountsByPlatform?.android || 0,
    unknown: Math.max(
      0,
      (s.newAccounts || 0)
        - (s.newAccountsByPlatform?.web || 0)
        - (s.newAccountsByPlatform?.ios || 0)
        - (s.newAccountsByPlatform?.android || 0)
    ),
  }));

  return (
    <div className="card p-6">
      <div className="flex items-center justify-between mb-1">
        <h3 className="font-bold text-ink-900 text-[0.9375rem]">New accounts</h3>
        <span className="text-xs text-ink-400">Last 30 days · by signup platform</span>
      </div>
      <p className="text-xs text-ink-400 mb-5">
        New user registrations per day. Stacked by the platform the signup happened on.
      </p>
      <ResponsiveContainer width="100%" height={280}>
        <BarChart data={data} margin={{ top: 5, right: 10, left: -10, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e0d6" vertical={false} />
          <XAxis dataKey="date" tick={{ fontSize: 11, fill: '#57534e' }} axisLine={{ stroke: '#e5e0d6' }} tickLine={false} />
          <YAxis tick={{ fontSize: 11, fill: '#57534e' }} axisLine={false} tickLine={false} allowDecimals={false} />
          <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(27, 107, 74, 0.05)' }} />
          <Legend iconType="circle" wrapperStyle={{ fontSize: 12, paddingTop: 8 }} />
          <Bar dataKey="web" name="Web" stackId="a" fill="#1B6B4A" radius={[0, 0, 0, 0]} />
          <Bar dataKey="ios" name="iOS" stackId="a" fill="#F5C842" />
          <Bar dataKey="android" name="Android" stackId="a" fill="#F2886D" />
          <Bar dataKey="unknown" name="Unknown" stackId="a" fill="#B8B2A8" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default NewAccountsChart;
